import PartyCover from './PartyCover';

export default PartyCover;
